exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".symbol {\n  font-size: 5rem; }\n\n.reduce-line-height {\n  line-height: 2rem; }\n\n.company_name_spacing {\n  padding: 0 0.1rem; }\n\ninput {\n  width: 12rem;\n  padding: 0rem 0.75rem 0rem 0.75rem;\n  font-family: \"browallia\", FontAwesome; }\n\nbutton {\n  width: 8rem; }\n\n.case-information {\n  height: 32px;\n  text-align: center;\n  border-radius: 1px;\n  background-color: rgba(255, 210, 0, 0.2); }\n\n.upload-btn-wrapper {\n  line-height: normal;\n  position: relative;\n  overflow: hidden;\n  display: inline-block; }\n\n.upload-btn {\n  border-radius: 3px; }\n\n.upload-btn-wrapper input[type=file] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0; }\n\n.row {\n  margin: 0.4rem 0 0.4rem 0; }\n\n.unset-width {\n  width: unset; }\n\n.label-width {\n  width: 18rem; }\n\n.close {\n  width: unset !important; }\n\n.before-submit-form {\n  border: 1px solid #dddbda; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/output-case/output-case.component.scss
// module id = ../../../../../src/app/crm/output-case/output-case.component.scss
// module chunks = main